import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    magic_link: null,
    preview_link: null,
    upload_link: null
  };
}

const state = initialState ();

// actions

const actions = {

  async generateMagicLink (context, payload) {
    var response = await API.screenerAccessLink.generateMagicLink (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async getPreviewLink (context, payload) {
    var response = await API.screenerAccessLink.getPreviewLink (payload);
    context.commit('set_preview_link',{
      preview_link: response.preview_link
    });
    return response;
  },

  async getMagicLink (context, payload) {
    var response = await API.screenerAccessLink.getMagicLink (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async markMagicLinkPaused (context, payload) {
    var response = await API.screenerAccessLink.markMagicLinkPaused (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async activateMagicLink (context, payload) {
    var response = await API.screenerAccessLink.activateMagicLink (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async markMagicLinkExpired (context, payload) {
    var response = await API.screenerAccessLink.markMagicLinkExpired (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async updateMagicLink (context, payload) {
    var response = await API.screenerAccessLink.updateMagicLink (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async deleteMagicLink (context, payload) {
    var response = await API.screenerAccessLink.deleteMagicLink (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async generateNewMagicLink (context, payload) {
    var response = await API.screenerAccessLink.generateNewMagicLink (payload);
    context.commit('set_magic_link',{
      magic_link: response.magic_link
    });
    return response;
  },

  async generateUploadLink(context, payload){
    var response = await API.screenerAccessLink.generateUploadLink (payload);
    context.commit('set_upload_link',{
      upload_link: response.upload_link
    });
    return response;
  },

  async getUploadLink(context, payload) {
    var response = await API.screenerAccessLink.getUploadLink (payload);
    context.commit('set_upload_link',{
      upload_link: response.upload_link
    });
    return response;
  },

  async deleteUploadLink (context, payload) {
    var response = await API.screenerAccessLink.deleteUploadLink (payload);
    context.commit('set_upload_link',{
      upload_link: response.upload_link
    });
    return response;
  },
};

// getters
const getters = {
  getField,
};

// mutations
const mutations = {
  updateField,
  set_magic_link (state, payload) {
    state.magic_link = payload.magic_link;
  },
  set_preview_link (state, payload) {
    state.preview_link = payload.preview_link;
  },
  set_upload_link (state,payload) {
    state.upload_link = payload.upload_link
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
